<template>
  <div :class="{ fullHeight: isFullHeight }">
    <slot />
  </div>
</template>

<script setup lang="ts">
import { toRefs } from 'vue'
import { useInjectedBreadcrumbs } from '../breadcrumbs/useBreadcrumbs'
import { type Breadcrumb } from '../types'

const props = defineProps<{
  breadcrumbs: Breadcrumb
  isFullHeight?: boolean
}>()

const { breadcrumbs, isFullHeight } = toRefs(props)
useInjectedBreadcrumbs(breadcrumbs)
</script>
<style lang="scss" scoped>
.fullHeight {
  height: 100%;
  display: flex;
  flex: 1 1 0;
  flex-direction: column;
}
</style>
